<template>
  <div>
    <CustomLabel v-if="inputLabel" :inputLabel="inputLabel" :inputId="inputId" />
    <div class="search-bar">
      <el-input
        :id="inputId"
        v-model="inputValue"
        type="text"
        class="w-100"
        :placeholder="searchPlaceholder"
        @input="onChange"
        :size="isTabletScreen || isSmall ? 'small' : 'default'"
      />
      <i class="search-icon bi bi-search color-info" @click="onSearch"></i>
      <i v-if="inputValue" class="clear-icon color-danger bi bi-x-lg" @click="onClear"></i>
    </div>
  </div>
</template>

<script lang="ts">
import { useSessionStore } from "@/stores/sessionStore";
import { storeToRefs } from "pinia";
import { defineComponent, ref, watch } from "vue";
import CustomLabel from "@/components/input/CustomLabel.vue";

export default defineComponent({
  name: "SearchBar",
  components: { CustomLabel },
  props: {
    inputId: { type: String, required: true },
    inputLabel: { type: String, required: false },
    initialValue: { type: String, default: "" },
    searchPlaceholder: { type: String, default: "" },
    isSmall: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const sessionStore = useSessionStore();
    const { isTabletScreen } = storeToRefs(sessionStore);
    const inputValue = ref(props.initialValue);
    watch(
      () => props.initialValue,
      (newValue) => {
        inputValue.value = newValue;
      },
    );
    function onChange() {
      emit("onChange", inputValue.value);
    }
    function onClear() {
      inputValue.value = "";
      emit("onChange", inputValue.value);
    }
    function onSearch() {
      emit("onSearch", inputValue.value);
    }

    return { isTabletScreen, inputValue, onChange, onClear, onSearch };
  },
});
</script>

<style lang="scss" scoped>
.search-bar {
  position: relative;
  border: none;
  max-width: 480px;
  font-size: $font-size-xxxs;
  & .search-icon {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
  & .clear-icon {
    cursor: pointer;
    position: absolute;
    top: 50%;
    right: 30px;
    transform: translateY(-50%);
  }
}
</style>
0
